import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await register(form.name, form.email, form.password);
    setLoading(false);
    if (res.ok) { toast.success("Conta criada com sucesso!"); navigate("/loja"); }
    else setError(res.error);
  };

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="min-h-[calc(100vh-68px)] grid md:grid-cols-2">
      <div className="flex items-center justify-center px-6 py-16 order-2 md:order-1">
        <motion.form onSubmit={submit} data-testid="register-form" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="w-full max-w-sm">
          <p className="label-caps text-rose mb-3">Criar Conta</p>
          <h1 className="font-serif-display font-light text-white text-5xl tracking-tight mb-8">Junte-se à Donna Nara.</h1>
          {error && <p data-testid="register-error" className="text-rose text-sm mb-4 border border-rose/40 px-4 py-2">{error}</p>}
          <label className="label-caps text-white/50 text-[10px]">Nome</label>
          <input data-testid="register-name" required value={form.name} onChange={upd("name")}
            className="w-full bg-surface border border-line focus:border-rose outline-none text-white px-4 py-3 mt-2 mb-5 transition-colors duration-300" />
          <label className="label-caps text-white/50 text-[10px]">E-mail</label>
          <input data-testid="register-email" type="email" required value={form.email} onChange={upd("email")}
            className="w-full bg-surface border border-line focus:border-rose outline-none text-white px-4 py-3 mt-2 mb-5 transition-colors duration-300" />
          <label className="label-caps text-white/50 text-[10px]">Senha (mín. 6 caracteres)</label>
          <input data-testid="register-password" type="password" required minLength={6} value={form.password} onChange={upd("password")}
            className="w-full bg-surface border border-line focus:border-rose outline-none text-white px-4 py-3 mt-2 mb-8 transition-colors duration-300" />
          <button data-testid="register-submit" disabled={loading} className="w-full bg-rose hover:bg-rose-hover text-ink font-bold py-4 label-caps transition-colors duration-300 disabled:opacity-50">
            {loading ? "Criando..." : "Criar Conta"}
          </button>
          <p className="text-white/50 text-sm mt-6">Já tem conta? <Link to="/entrar" className="text-rose hover:underline">Entrar</Link></p>
        </motion.form>
      </div>
      <div className="hidden md:block relative overflow-hidden order-1 md:order-2">
        <img src="https://images.unsplash.com/photo-1664893876112-64c308bf0d70?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-l from-ink/40 to-ink" />
      </div>
    </div>
  );
}
